var _circle, _circle2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLowMonthlyPaymentIcon = function SvgLowMonthlyPaymentIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.95,
    cy: 13,
    r: 10.461,
    fill: "#FFD355"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.637,
    cy: 11.843,
    r: 9.961,
    stroke: "#000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.8,
    d: "M21.868.926v3.226M20.11 2.528h3.516"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M14.253 14.61c0 .501-.122.981-.368 1.44-.245.448-.613.821-1.104 1.12-.49.298-1.088.464-1.792.496v1.28h-.704V17.65c-.95-.086-1.717-.395-2.304-.928a2.86 2.86 0 0 1-.944-2.016h1.2c.043.48.235.917.576 1.312.352.384.843.618 1.472.704V12.29c-.714-.192-1.29-.384-1.728-.576a2.785 2.785 0 0 1-1.088-.88c-.298-.406-.448-.944-.448-1.616 0-.843.294-1.536.88-2.08.587-.555 1.382-.854 2.384-.896V4.898h.704v1.36c.886.085 1.595.373 2.128.864.534.49.848 1.104.944 1.84h-1.184c-.064-.395-.261-.763-.592-1.104-.32-.342-.752-.555-1.296-.64v4.272c.694.181 1.259.373 1.696.576.448.192.822.49 1.12.896.299.405.448.954.448 1.648ZM8.157 9.17c0 .597.182 1.05.544 1.36.374.298.902.549 1.584.752V7.17c-.64.032-1.157.218-1.552.56-.384.341-.576.821-.576 1.44Zm2.832 7.584c.683-.043 1.21-.256 1.584-.64.374-.395.56-.88.56-1.456 0-.608-.186-1.067-.56-1.376-.362-.31-.89-.571-1.584-.784v4.256Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLowMonthlyPaymentIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "low-monthly-payment-icon.7900fecf98ba6bc454a61a482397fb0c.svg";